import { Col, Form, Row, Select, Input } from "antd";
import { useEffect, useState } from "react";

import { GET_BUYER_ENDPOINT } from "../../../apiServices/API_ENDPOINTS";
import { getData } from "../../../apiServices/common";
const SalesContractFilterFields = ({ initialTableData }) => {
  const [buyerList, setBuyerList] = useState([]);
  const { Option } = Select;

  const getBuyerList = async (filterValues = {}) => {
    const query = `${GET_BUYER_ENDPOINT}`;
    const bodyData = { per_page: 10, name: filterValues?.name || "" };
    const res = await getData(query, false, bodyData);
    if (res) setBuyerList(res?.data?.data?.data || []);
  };

  useEffect(() => {
    getBuyerList();
  }, []);
  return (
    <>
      {/* <Col span={4}>
        <Form.Item
          label="Sales Contract Unique ID"
          name="sales_contract_unique_id"
        >
          <Input size="small" placeholder="Write Sales Contract Unique ID" />
        </Form.Item>
      </Col> */}
      {/* Buyer */}
      <Col span={4}>
        <Form.Item label="Buyer" name="buyer_id">
          <Select
            showSearch
            placeholder="Select a Buyer"
            optionFilterProp="children"
            size="small"
            onSearch={(value) => getBuyerList({ name: value })}
            allowClear
            onClear={() => getBuyerList()}
          >
            {buyerList.map((buyer) => (
              <Option key={buyer.id} value={buyer.id}>
                {buyer.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item label="Sales Contract" name="reference_no">
          <Input size="small" placeholder="Write Sales Contract" />
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item label="Contract Date" name="contract_date">
          <Input size="small" placeholder="Contract Date" />
        </Form.Item>
      </Col>
    </>
  );
};

export default SalesContractFilterFields;
